<template>
	<v-container v-show="mounted" class="fill-height">
		<v-row class="my-auto" no-gutters align="center" justify="center" style="min-height: 20%;">
			<v-col cols="12" class="text-center" align-self="end">
				<span class="text-h4 font-weight-medium">{{ $t("Home.Hello") }}, {{ firstName }}</span>
			</v-col>
			<v-col cols="12"  align-self="start">
				<div class="d-flex align-center justify-center">
					<v-icon color="primary">mdi-domain</v-icon>
					<span class="text-h6 font-weight-light ml-2">{{ customerName }}</span>
				</div>
			</v-col>
		</v-row>

		<!-- WORK IN PROGRESS -->
		<v-row v-if="dashboardInfo.length > 0" class="my-auto">				
			<v-col cols="12">
				<v-card flat color="transparent">
					<v-card-text>
					<v-row justify="space-around">
						<v-col cols="12" sm="auto" v-for="item in dashboardInfo" :key="item.itemId" align-self="center">
							<v-card flat rounded :to="{ name: item.itemName }" width="200" outlined>
								<v-card-title class="text-subtitle-1">
									{{ $t('Home.' + item.itemLabel) }}
								</v-card-title>
								<v-card-text class="text-h4 text-center primary--text">{{ item.itemCount }}</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>				
				</v-card>
			</v-col>
		</v-row>

		<!-- SHORTCUTS -->
		<v-row align="center" justify="space-around" class="my-auto" style="min-height: 20%;">
			<v-col cols="12" sm="5">
				<v-btn text outlined block color="primary" x-large  class="text-none" :to="{ name: 'MyProducts' }">{{ $t("Home.My_products") }}</v-btn>
			</v-col>
			<v-col cols="12" sm="5">
				<v-btn text outlined block color="primary" x-large  class="text-none" :to="{ name: 'SalesInvoices' }">{{ $t("Home.My_invoices") }}</v-btn>
			</v-col>		
		</v-row>

		<!-- WEBSHOP -->			
		<v-row class="my-auto">
			<v-col cols="12">
				<v-card flat color="grey lighten-4">
					<v-card-title c>{{ $t("Home.Webshop") }}</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="3" v-for="mainCategory in mainCategories" :key="mainCategory.id" align="center">
								<SubCategoryCard :subCategory="mainCategory" @select="selectSubCategory" class="transparent" />
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import store from "@/store";
import { mapGetters } from "vuex";
import SubCategoryCard from "../components/SubCategoryCard.vue";
export default {
	name: "Home",
	components: {
		SubCategoryCard,
	},
	mounted() {
		const that = this;
		store.dispatch("session/fetchDashboardInfo").then(() => {
			that.mounted = true;
		});
		store.dispatch("catalog/fetchCatalog");
	},
	data() {
		return {
			mounted: false,
		};
	},
	computed: {
		...mapGetters({
			firstName: "session/firstName",
			customerName: "session/customerName",
			dashboardInfo: "session/dashboardInfo",
			mainCategories: "catalog/mainCategories",
		}),
		shortCuts() {
			const kmp = [
				{
					label: this.$t("Home.My_products"),
					routeName: { name: "MyProducts" },
				},
				{
					label: this.$t("Home.My_invoices"),
					routeName: { name: "SalesInvoices" },
				},
				
			];
			return kmp;
		},
	},
	methods: {
		selectSubCategory(subCategory) {
			this.$router.push({ name: 'ProductCategory', params: { id: subCategory.id } });
		},
	}
};
</script>
